module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/3/2-93070e5c0e512ededba77dc6bafa3fb7.jpg";